import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { request } from '../api/client';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) {
      setError('请输入邮箱');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      // 发送重置密码邮件（后端暂未实现，但预留接口）
      await request<{ ok: boolean }>('/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim() }),
      });
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : '发送失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg-subtle px-4">
        <div className="w-full max-w-md rounded-2xl border border-border bg-bg-surface p-8 text-center shadow-sm">
          <CheckCircle className="mx-auto h-12 w-12 text-[#22c55e]" />
          <h1 className="mt-4 text-xl font-semibold">邮件已发送</h1>
          <p className="mt-2 text-sm text-text-secondary">
            如果该邮箱已注册，您将收到一封密码重置邮件，请查收。
          </p>
          <Link to="/login" className="btn btn-primary btn-md mt-6 inline-flex">
            返回登录
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-subtle px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-bg-surface p-8 shadow-sm">
        <Link
          to="/login"
          className="mb-4 flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary"
        >
          <ArrowLeft className="h-4 w-4" /> 返回登录
        </Link>
        <h1 className="text-xl font-semibold">忘记密码</h1>
        <p className="mt-1 text-sm text-text-secondary">
          输入您的注册邮箱，我们将发送密码重置链接。
        </p>
        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium" htmlFor="reset-email">
              邮箱 <span className="text-danger">*</span>
            </label>
            <input
              id="reset-email"
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              placeholder="your@example.com"
            />
          </div>
          {error && <p className="text-sm text-danger">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary btn-md w-full"
          >
            {loading ? (
              '发送中…'
            ) : (
              <>
                <Mail className="h-4 w-4" /> 发送重置邮件
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}